const InvoiceHeader = ({ isChecked, onSelectAll }) => (
    <thead className="bg-gray-100">
      <tr>
        <th className="border px-4 py-2">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => onSelectAll(e.target.checked)}
          />
        </th>
        <th className="border px-4 py-2">Invoice No</th>
        <th className="border px-4 py-2">Date</th>
        <th className="border px-4 py-2">Ship To</th>
        <th className="border px-4 py-2">Bill To</th>
        <th className="border px-4 py-2">Currency</th>
        <th className="border px-4 py-2 text-right">Amount</th>
      </tr>
    </thead>
  );
  
  export default InvoiceHeader;
  